import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/components/ghicons/Curve.svg';
import _imports_1 from '@/components/ghicons/project.svg';
import _imports_2 from '@/components/ghicons/Panel.svg';
import _imports_3 from '@/components/ghicons/Random.svg';
const _hoisted_1 = {
  class: "toolbarlayout"
};
const _hoisted_2 = {
  style: {
    "margin": "20px 0"
  }
};
const _hoisted_3 = {
  class: "DiscriptionContent"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");
  const _component_GHComponent = _resolveComponent("GHComponent");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  const _component_el_divider = _resolveComponent("el-divider");
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");
  const _component_el_descriptions = _resolveComponent("el-descriptions");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_breadcrumb, {
    "separator-class": "el-icon-arrow-right",
    class: "elbreadcrumb"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_breadcrumb_item, {
      to: {
        path: '/GrasshopperTabs'
      }
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [_createTextVNode("Home")])),
      _: 1,
      __: [0]
    }), _createVNode(_component_el_breadcrumb_item, {
      to: {
        path: '/GrasshopperTabs'
      }
    }, {
      default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("Grasshopper")])),
      _: 1,
      __: [1]
    }), _createVNode(_component_el_breadcrumb_item, null, {
      default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("Display")])),
      _: 1,
      __: [2]
    })]),
    _: 1
  })]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_scrollbar, {
    always: "true"
  }, {
    default: _withCtx(() => [_createVNode(_component_GHComponent)]),
    _: 1
  }), _createVNode(_component_el_divider), _cache[37] || (_cache[37] = _createElementVNode("div", {
    class: "el-descriptions__header",
    style: {
      "flex-direction": "column",
      "justify-content": "center"
    }
  }, [_createElementVNode("h2", null, "Graphs"), _createElementVNode("p", null, "包括6个运算器")], -1)), _createVNode(_component_el_descriptions, {
    column: 2,
    border: "",
    class: "descriptions"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
      "label-align": "center",
      align: "left",
      "min-width": "60px",
      span: "1"
    }, {
      label: _withCtx(() => _cache[3] || (_cache[3] = [_createElementVNode("a", {
        class: "logoLink",
        href: "#",
        target: "_blank"
      }, [_createElementVNode("img", {
        class: "ghicon",
        src: _imports_0,
        alt: ""
      }), _createElementVNode("h4", {
        class: "Componentname"
      }, "Point List")], -1)])),
      default: _withCtx(() => [_cache[4] || (_cache[4] = _createElementVNode("p", null, "Displays details about lists of points", -1))]),
      _: 1,
      __: [4]
    }), _createVNode(_component_el_descriptions_item, {
      "label-align": "center",
      align: "left",
      "min-width": "60px",
      span: "1"
    }, {
      label: _withCtx(() => _cache[5] || (_cache[5] = [_createElementVNode("a", {
        class: "logoLink",
        href: "#",
        target: "_blank"
      }, [_createElementVNode("img", {
        class: "ghicon",
        src: _imports_1,
        alt: ""
      }), _createElementVNode("h4", {
        class: "Componentname"
      }, "Point List")], -1)])),
      default: _withCtx(() => [_cache[6] || (_cache[6] = _createElementVNode("p", null, "Displays details about lists of points", -1))]),
      _: 1,
      __: [6]
    }), _createVNode(_component_el_descriptions_item, {
      "label-align": "center",
      align: "left",
      "min-width": "60px",
      span: "1"
    }, {
      label: _withCtx(() => _cache[7] || (_cache[7] = [_createElementVNode("a", {
        class: "logoLink",
        href: "#",
        target: "_blank"
      }, [_createElementVNode("img", {
        class: "ghicon",
        src: _imports_2,
        alt: ""
      }), _createElementVNode("h4", {
        class: "Componentname"
      }, "Point List")], -1)])),
      default: _withCtx(() => [_cache[8] || (_cache[8] = _createElementVNode("p", null, "Displays details about lists of points", -1))]),
      _: 1,
      __: [8]
    }), _createVNode(_component_el_descriptions_item, {
      "label-align": "center",
      align: "left",
      "min-width": "60px",
      span: "1"
    }, {
      label: _withCtx(() => _cache[9] || (_cache[9] = [_createElementVNode("a", {
        class: "logoLink",
        href: "#",
        target: "_blank"
      }, [_createElementVNode("img", {
        class: "ghicon",
        src: _imports_0,
        alt: ""
      }), _createElementVNode("h4", {
        class: "Componentname"
      }, "Point List")], -1)])),
      default: _withCtx(() => [_cache[10] || (_cache[10] = _createElementVNode("p", null, "Displays details about lists of points", -1))]),
      _: 1,
      __: [10]
    }), _createVNode(_component_el_descriptions_item, {
      "label-align": "center",
      align: "left",
      "min-width": "60px",
      span: "1"
    }, {
      label: _withCtx(() => _cache[11] || (_cache[11] = [_createElementVNode("a", {
        class: "logoLink",
        href: "#",
        target: "_blank"
      }, [_createElementVNode("img", {
        class: "ghicon",
        src: _imports_1,
        alt: ""
      }), _createElementVNode("h4", {
        class: "Componentname"
      }, "Point List")], -1)])),
      default: _withCtx(() => [_cache[12] || (_cache[12] = _createElementVNode("p", null, "Displays details about lists of points", -1))]),
      _: 1,
      __: [12]
    }), _createVNode(_component_el_descriptions_item, {
      "label-align": "center",
      align: "left",
      "min-width": "60px",
      span: "1"
    }, {
      label: _withCtx(() => _cache[13] || (_cache[13] = [_createElementVNode("a", {
        class: "logoLink",
        href: "#",
        target: "_blank"
      }, [_createElementVNode("img", {
        class: "ghicon",
        src: _imports_2,
        alt: ""
      }), _createElementVNode("h4", {
        class: "Componentname"
      }, "Point List")], -1)])),
      default: _withCtx(() => [_cache[14] || (_cache[14] = _createElementVNode("p", null, "Displays details about lists of points", -1))]),
      _: 1,
      __: [14]
    })]),
    _: 1
  }), _cache[38] || (_cache[38] = _createElementVNode("div", {
    class: "el-descriptions__header",
    style: {
      "flex-direction": "column",
      "justify-content": "center"
    }
  }, [_createElementVNode("h2", null, "Preview"), _createElementVNode("p", null, "包括7个运算器")], -1)), _createVNode(_component_el_descriptions, {
    column: 2,
    border: "",
    class: "descriptions"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
      "label-align": "center",
      align: "left",
      "max-width": "60px",
      span: "1"
    }, {
      label: _withCtx(() => _cache[15] || (_cache[15] = [_createElementVNode("a", {
        class: "logoLink",
        href: "#",
        target: "_blank"
      }, [_createElementVNode("img", {
        class: "ghicon",
        src: _imports_0,
        alt: ""
      }), _createElementVNode("h4", {
        class: "Componentname"
      }, "Point List")], -1)])),
      default: _withCtx(() => [_cache[16] || (_cache[16] = _createElementVNode("p", null, "Displays details about lists of points", -1))]),
      _: 1,
      __: [16]
    }), _createVNode(_component_el_descriptions_item, {
      "label-align": "center",
      align: "left",
      "max-width": "60px",
      span: "1"
    }, {
      label: _withCtx(() => _cache[17] || (_cache[17] = [_createElementVNode("a", {
        class: "logoLink",
        href: "#/CurrentOperator"
      }, [_createElementVNode("img", {
        class: "ghicon",
        src: _imports_3,
        alt: ""
      }), _createElementVNode("h4", {
        class: "Componentname"
      }, "Point List")], -1)])),
      default: _withCtx(() => [_cache[18] || (_cache[18] = _createElementVNode("p", null, "Displays details about lists of points", -1))]),
      _: 1,
      __: [18]
    }), _createVNode(_component_el_descriptions_item, {
      "label-align": "center",
      align: "left",
      "max-width": "60px",
      span: "1"
    }, {
      label: _withCtx(() => _cache[19] || (_cache[19] = [_createElementVNode("a", {
        class: "logoLink",
        href: "#",
        target: "_blank"
      }, [_createElementVNode("img", {
        class: "ghicon",
        src: _imports_2,
        alt: ""
      }), _createElementVNode("h4", {
        class: "Componentname"
      }, "Point List")], -1)])),
      default: _withCtx(() => [_cache[20] || (_cache[20] = _createElementVNode("p", null, "Displays details about lists of points", -1))]),
      _: 1,
      __: [20]
    }), _createVNode(_component_el_descriptions_item, {
      "label-align": "center",
      align: "left",
      "max-width": "60px",
      span: "1"
    }, {
      label: _withCtx(() => _cache[21] || (_cache[21] = [_createElementVNode("a", {
        class: "logoLink",
        href: "#",
        target: "_blank"
      }, [_createElementVNode("img", {
        class: "ghicon",
        src: _imports_1,
        alt: ""
      }), _createElementVNode("h4", {
        class: "Componentname"
      }, "Point List")], -1)])),
      default: _withCtx(() => [_cache[22] || (_cache[22] = _createElementVNode("p", null, "Displays details about lists of points", -1))]),
      _: 1,
      __: [22]
    }), _createVNode(_component_el_descriptions_item, {
      "label-align": "center",
      align: "left",
      "min-width": "60px",
      span: "1"
    }, {
      label: _withCtx(() => _cache[23] || (_cache[23] = [_createElementVNode("a", {
        class: "logoLink",
        href: "#",
        target: "_blank"
      }, [_createElementVNode("img", {
        class: "ghicon",
        src: _imports_0,
        alt: ""
      }), _createElementVNode("h4", {
        class: "Componentname"
      }, "Point List")], -1)])),
      default: _withCtx(() => [_cache[24] || (_cache[24] = _createElementVNode("p", null, "Displays details about lists of points", -1))]),
      _: 1,
      __: [24]
    }), _createVNode(_component_el_descriptions_item, {
      "label-align": "center",
      align: "left",
      "min-width": "60px",
      span: "1"
    }, {
      label: _withCtx(() => _cache[25] || (_cache[25] = [_createElementVNode("a", {
        class: "logoLink",
        href: "#",
        target: "_blank"
      }, [_createElementVNode("img", {
        class: "ghicon",
        src: _imports_1,
        alt: ""
      }), _createElementVNode("h4", {
        class: "Componentname"
      }, "Point List")], -1)])),
      default: _withCtx(() => [_cache[26] || (_cache[26] = _createElementVNode("p", null, "Displays details about lists of points", -1))]),
      _: 1,
      __: [26]
    }), _createVNode(_component_el_descriptions_item, {
      "label-align": "center",
      align: "left",
      "min-width": "60px",
      span: "1"
    }, {
      label: _withCtx(() => _cache[27] || (_cache[27] = [_createElementVNode("a", {
        class: "logoLink",
        href: "#",
        target: "_blank"
      }, [_createElementVNode("img", {
        class: "ghicon",
        src: _imports_2,
        alt: ""
      }), _createElementVNode("h4", {
        class: "Componentname"
      }, "Point List")], -1)])),
      default: _withCtx(() => [_cache[28] || (_cache[28] = _createElementVNode("p", null, "Displays details about lists of points", -1))]),
      _: 1,
      __: [28]
    })]),
    _: 1
  }), _cache[39] || (_cache[39] = _createElementVNode("div", {
    class: "el-descriptions__header",
    style: {
      "flex-direction": "column",
      "justify-content": "center"
    }
  }, [_createElementVNode("h2", null, "Vector"), _createElementVNode("p", null, "包括4个运算器")], -1)), _createVNode(_component_el_descriptions, {
    column: 2,
    border: "",
    class: "descriptions"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
      "label-align": "center",
      align: "left",
      "min-width": "60px",
      span: "1"
    }, {
      label: _withCtx(() => _cache[29] || (_cache[29] = [_createElementVNode("a", {
        class: "logoLink",
        href: "#",
        target: "_blank"
      }, [_createElementVNode("img", {
        class: "ghicon",
        src: _imports_2,
        alt: ""
      }), _createElementVNode("h4", {
        class: "Componentname"
      }, "Point List")], -1)])),
      default: _withCtx(() => [_cache[30] || (_cache[30] = _createElementVNode("p", null, "Displays details about lists of points", -1))]),
      _: 1,
      __: [30]
    }), _createVNode(_component_el_descriptions_item, {
      "label-align": "center",
      align: "left",
      "min-width": "60px",
      span: "1"
    }, {
      label: _withCtx(() => _cache[31] || (_cache[31] = [_createElementVNode("a", {
        class: "logoLink",
        href: "#",
        target: "_blank"
      }, [_createElementVNode("img", {
        class: "ghicon",
        src: _imports_2,
        alt: ""
      }), _createElementVNode("h4", {
        class: "Componentname"
      }, "Point List")], -1)])),
      default: _withCtx(() => [_cache[32] || (_cache[32] = _createElementVNode("p", null, "Displays details about lists of points", -1))]),
      _: 1,
      __: [32]
    }), _createVNode(_component_el_descriptions_item, {
      "label-align": "center",
      align: "left",
      "min-width": "60px",
      span: "1"
    }, {
      label: _withCtx(() => _cache[33] || (_cache[33] = [_createElementVNode("a", {
        class: "logoLink",
        href: "#",
        target: "_blank"
      }, [_createElementVNode("img", {
        class: "ghicon",
        src: _imports_2,
        alt: ""
      }), _createElementVNode("h4", {
        class: "Componentname"
      }, "Point List")], -1)])),
      default: _withCtx(() => [_cache[34] || (_cache[34] = _createElementVNode("p", null, "Displays details about lists of points", -1))]),
      _: 1,
      __: [34]
    }), _createVNode(_component_el_descriptions_item, {
      "label-align": "center",
      align: "left",
      "min-width": "60px",
      span: "1"
    }, {
      label: _withCtx(() => _cache[35] || (_cache[35] = [_createElementVNode("a", {
        class: "logoLink",
        href: "#",
        target: "_blank"
      }, [_createElementVNode("img", {
        class: "ghicon",
        src: _imports_2,
        alt: ""
      }), _createElementVNode("h4", {
        class: "Componentname"
      }, "Point List")], -1)])),
      default: _withCtx(() => [_cache[36] || (_cache[36] = _createElementVNode("p", null, "Displays details about lists of points", -1))]),
      _: 1,
      __: [36]
    })]),
    _: 1
  })])]);
}